type Props = {
  isSvg: boolean;
  borderSize: string;
  styles: { readonly [key: string]: string };
};

export default function handleBorderSize({ isSvg, borderSize, styles }: Props) {
  if (isSvg) {
    switch (borderSize) {
      case "small":
        return styles._small_border;
      case "large":
        return styles._large_border;
    }
  } else {
    return "";
  }
}
